import { take, call, put, takeEvery, select, takeLatest } from 'redux-saga/effects';

import { addFiltersToParams } from 'components/statistics/audit/questions/QuestionsUtils';
import { restClient } from 'config/store/configureStore';
import * as types from 'constants/ActionTypes';

import { getAuditStatisticsFilters, getAuditStatisticsIsFetching } from 'selectors/auditStatisticsSelectors';
import { filter } from 'utils/global';

import * as auditStatisticsActions from '../actions/auditStatisticsActions';

import AuditStatisticsService from '../services/api/AuditStatisticsService';

function* fetchAuditStatistics(action) {
  const filters = yield select(getAuditStatisticsFilters);
  const { params } = action;

  const paramsWithFilters = addFiltersToParams(params, filters);
  try {
    const isFetchings = yield select(getAuditStatisticsIsFetching);
    const isFetching = filter(item => !!item, isFetchings);
    const countFetchings = Object.keys(isFetching).length;
    if (countFetchings > 3) {
      for (let i = 0; i < countFetchings - 3; i++) {
        yield take(types.FETCH_AUDIT_STATISTICS_DONE);
      }
    }

    const response = yield call(AuditStatisticsService.getAuditStatisticsForQuestion, action.links, paramsWithFilters);
    yield put(auditStatisticsActions.fetchAuditStatisticsDone());
    yield put(auditStatisticsActions.fetchAuditStatisticsSuccess(paramsWithFilters.questionId, response.data));
  } catch (e) {
    yield put(auditStatisticsActions.fetchAuditStatisticsDone());
    yield put(auditStatisticsActions.fetchAuditStatisticsFailure(e, action.params.questionId));
  }
}

function* fetchAuditStatisticsCount(action) {
  const filters = yield select(getAuditStatisticsFilters);
  const { params } = action;

  const paramsWithFilters = addFiltersToParams(params, filters);
  try {
    const response = yield call(AuditStatisticsService.getAuditStatisticsForQuestion, {}, paramsWithFilters);
    yield put(auditStatisticsActions.fetchStatisticsCountSuccess(response.data));
  } catch (e) {
    yield put(auditStatisticsActions.fetchStatisticsCountFailure(e));
  }
}

function* fetchAuditStatisticsAvgTime(action) {
  const filters = yield select(getAuditStatisticsFilters);
  const { request } = action.payload;
  const { params } = request;

  const paramsWithFilters = addFiltersToParams(params, filters);
  try {
    const response = yield call(restClient.request, { ...request, params: paramsWithFilters });
    yield put(auditStatisticsActions.fetchStatisticsAvgTimeSuccess(response.data));
  } catch (error) {
    yield put(auditStatisticsActions.fetchStatisticsAvgTimeFailure(error));
  }
}

function* fetchAuditStatisticsAudits(action) {
  const filters = yield select(getAuditStatisticsFilters);
  const { params } = action;

  const paramsWithFilters = addFiltersToParams(params, filters);
  try {
    const response = yield call(AuditStatisticsService.getAuditStatisticsForQuestion, action.links, paramsWithFilters);
    yield put(auditStatisticsActions.fetchLinkedAuditsSuccess(response.data));
  } catch (e) {
    yield put(auditStatisticsActions.fetchLinkedAuditsFailure(e));
  }
}

export default function* auditStatisticsSagas() {
  yield takeEvery(types.FETCH_AUDIT_STATISTICS_REQUEST, fetchAuditStatistics);
  yield takeLatest(types.FETCH_AUDIT_STATISTICS_COUNT_REQUEST, fetchAuditStatisticsCount);
  yield takeLatest(types.FETCH_AUDIT_STATISTICS_AUDITS_REQUEST, fetchAuditStatisticsAudits);
  yield takeLatest(types.FETCH_AUDIT_STATISTICS_AVG_TIME_REQUEST, fetchAuditStatisticsAvgTime);
}
